import React, { useCallback, useRef, useState } from 'react';
import { useIncarnateSuggest } from '../../features/mrWolf/hooks/useMrWolfState';
import { useIncarnateModal, useSetIncarnateModal } from '../../features/global/hooks';
import { Modal, Textinput, theme } from '../../ui';
import styled from 'styled-components';
import debounce from 'lodash.debounce';
import { useIncarnate } from '../../features/auth/hooks/useAuthActions';

const SuggestContainer = styled.div`
  position: absolute;
  border: 1px solid ${theme.colors.NEU_300};
  background-color: ${theme.colors.NEU_0};
  max-height: 250px;
  overflow-y: scroll;
`

const SuggestBlock = styled.div`
  padding: 3px 5px;
  cursor: pointer;
  line-height: 100%;
`

const SuggestDescription = styled.div`
  font-size: ${theme.fontSizes.xSmall}
`

const IncarnateModal = () => {
  const setIncarnateModal = useSetIncarnateModal();
  const incRef = useRef(null);
  const incarnationOpen = useIncarnateModal();
  const [isSuggest, setSuggest] = useState(false);

  const incarnate = useIncarnate();
  const [incarnateSuggest, { userSuggest }] = useIncarnateSuggest();

  const handleIncarnation = useCallback(async () => {
    const captionToEqual = (user) => Number(incRef.current.value) ? user.id : user.caption;
    const valueToEqual = Number(incRef.current.value) ? Number(incRef.current.value) : incRef.current.value
    const neededUser = userSuggest.find(user => captionToEqual(user) === valueToEqual);

    if (!neededUser?.id) {
      console.log('User not found for incarnation');
      return;
    }

    await incarnate({ userId: neededUser.id });
    setIncarnateModal(false);
  }, [setIncarnateModal, userSuggest, incarnate]);

  const closeIncarnationModal = useCallback(() => {
    setIncarnateModal(false)
  }, [setIncarnateModal]);

  const handleSuggest = useCallback(debounce(() => {
    const { current: { value } } = incRef;

    if (value.length < 3 && isNaN(parseInt(value, 10))) {
      if (isSuggest) setSuggest(false);
      return null;
    }
    setSuggest(true);
    incarnateSuggest({ params: value });
  }, 1000), [incarnateSuggest, isSuggest]);

  const pickSuggestion = useCallback((user) => {
    incRef.current.value = user.caption;
    setSuggest(false);
  }, [])

  return (
    <Modal
      title={'Incarnate - Enter user email or user ID'}
      onClose={closeIncarnationModal}
      onAccept={handleIncarnation}
      showActions
      open={incarnationOpen}
      acceptLabel={'Incarnate'}
      overflow={'visible'}
    >
      <Textinput
        autoFocus
        margin="dense"
        id="incarnate"
        type="text"
        fullWidth
        inputRef={incRef}
        onChange={handleSuggest}
      />
      {isSuggest && <SuggestContainer>
        {userSuggest.map(user => {
          return <SuggestBlock
            key={user.id}
            onClick={() => pickSuggestion(user)}
          >
            <div>{user.caption}</div>
            <SuggestDescription>
              {`${user.descr[0]}, ${user.descr[1]}, ${user.descr[2]}`}
            </SuggestDescription>
          </SuggestBlock>
        })}
      </SuggestContainer>}
    </Modal>
  )
};

export default IncarnateModal;
